export default __webpack_public_path__ + "static/media/ActiveHeaderCart.58e753ed.svg";